import { useEffect, useState, useCallback } from 'react';
import { getOfflineStorageEstimate, OfflineStorageEstimate } from '@/lib/offlineEpisodes';

export function useOfflineStorageEstimate() {
  const [estimate, setEstimate] = useState<OfflineStorageEstimate | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    const est = await getOfflineStorageEstimate();
    setEstimate(est);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { estimate, loading, refresh };
}
